export const UPDATE_DRAWER_NAVIGATION_MENU_STATE =
  'UPDATE_DRAWER_NAVIGATION_MENU_STATE'
export const UPDATE_THEME = 'UPDATE_THEME'
export const UPDATE_SERVER_DATA_FETCH_ERROR = 'UPDATE_SERVER_DATA_FETCH_ERROR'
